export default "__VITE_ASSET__BjZcqorS__"